    import api                          from "../../services/api";
    import PxoDemandTable               from "./PxoDemandTable";
    import { usePxoPage }               from "../../contexts/PxoPageContext";
    import { useState, useEffect }      from "react";

    const PxoDemandaTableContainer = ({ tableData }) => {
        
        const { 

            pxoId, 
            handleUpdateDemandSection, 
            handleUpdateDescargaTable, 
            setIsModalDemandTableOpen,
            setSelectedDemandTableEdit

        } = usePxoPage();

        const [ localTableData, setLocalTableData   ] = useState(tableData);    
        const [ data,           setData             ] = useState(null)

        const handleConsiderInDescargaTable = async (demandTableId) => {
        
            try {
                
                const response = await api.post(`/considerInDescargaTable/${demandTableId}`, {
                    pxoId,
                });

                const { demandPostsComposed } = response.data

                setData(demandPostsComposed)

                handleUpdateDemandSection()
                handleUpdateDescargaTable()

            } catch (error) {
                console.log(error);
            }
        }

        const handleEditDemandTable = (demandTableId) => {

            setSelectedDemandTableEdit(demandTableId)
            setIsModalDemandTableOpen(true)

        }

        return (
            <>
                
                <PxoDemandTable
                    tableData={tableData}
                    onClickButton={handleConsiderInDescargaTable}
                    onClickEditButton={(demandTableId) => handleEditDemandTable(demandTableId)}
                />

            </>
        );
    };

    export default PxoDemandaTableContainer;